import { useTranslations } from '@lang';
import { useSelector } from 'react-redux';
import { entitySelectors } from '@store/entity';
import { useNavigationLabels } from './queries';
import { getLanguageCodeFromLocale } from '@utils/getLanguageCodeFromLocale';

export function useLabels() {
  const { locale } = useTranslations();
  const { data } = useNavigationLabels();
  const property = useSelector(entitySelectors.getProperty) as
    | { defaultLanguage?: string }
    | undefined;
  const defaultLanguage = property?.defaultLanguage;

  const currentLabels = data?.[getLanguageCodeFromLocale(locale)] || {};
  const defaultLabels = defaultLanguage ? data?.[defaultLanguage] || {} : {};

  const mergedLabels: { [key: string]: string } = { ...defaultLabels };
  Object.entries(currentLabels).forEach(([key, value]) => {
    if (value) mergedLabels[key] = value;
  });

  return mergedLabels;
}
